import {
  faFileCircleExclamation,
  faFileCode,
  faFileLines,
  faFilePdf,
  faFileZipper,
  faImage,
  faMusic,
} from "@fortawesome/free-solid-svg-icons";

export const getFileIcon = (fileFormat) => {
  switch (fileFormat) {
    case "zip":
    case "rar":
      return faFileZipper;
    case "bat":
      return faFileCode;
    case "txt":
      return faFileLines;
    case "mad":
      return faFileCircleExclamation;
    case "wav":
      return faMusic;
    case "pdf":
      return faFilePdf;
    case "jpg":
    case "png":
    case "jpeg":
      return faImage;
    default:
      return faFileLines;
  }
};

export const getFileExtension = (fileName, separator = ".") =>
  fileName.split(separator).pop() || "unknown";

export const isImageFile = (file) => {
  const imageMimeTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
  ];
  return imageMimeTypes.includes(file.type);
};

export const convertFileToAttachment = (file) => ({
  name: file.name,
  size: `${(file.size / 1024).toFixed(2)} KB`,
  format: getFileExtension(file.name),
  preview: isImageFile(file) ? URL.createObjectURL(file) : undefined,
});
